import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _compact from 'lodash/compact';
import SVG from 'react-inlinesvg';
import chevronDownIcon from '@lifesize/ux-assets/vectors/svgIcons/chevron-down.svg';
import chevronUpIcon from '@lifesize/ux-assets/vectors/svgIcons/chevron-up.svg';
import classes from 'components/Chat/ChatList.module.scss';

const UnreadChatNav = (props) => {
  const unreadClassName = _compact([
    classes.unreadChatNav,
    classes[props.scrollType]
  ]).join(' ');

  if (!props.showScroll) {
    return null;
  }

  const handleClick = () => {
    props.scrollToPos(props.scrollType);
  };

  return (
    <button
      className={unreadClassName}
      onClick={handleClick}
    >
      <label>
        <FormattedMessage
          id="components.chat.unreadChatNav"
          defaultMessage="unread"
        />
        <SVG src={props.scrollType === 'top' ? chevronUpIcon : chevronDownIcon} />
      </label>
    </button>
  );
};

UnreadChatNav.propTypes = {
  scrollType: PT.string,
  showScroll: PT.any,
  scrollToPos: PT.func
};

export default UnreadChatNav;
